export default __webpack_public_path__ + "static/media/buy.e941fd05.mp3";